module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-02-b 25.a378a2e5.png";